import imageYohan from "../photo/imageYohan.jpg";
import {NavLink} from "react-router-dom";
import { FaArrowCircleLeft } from "react-icons/fa";
import {IconContext} from "react-icons";
import image4Ho from '../photo/Evenement/image4Ho.jpg'
import image20Ho from '../photo/Paysage/image20Ho.jpg'
import image18Ho from '../photo/Paysage/image18Ho.jpg'
export const Portfolio = () => {
  return (
    <main className="min-h-screen bg-[#0B0B0F] text-white">
      {/* Navigation */}
      <div className="fixed top-5 left-5 z-50">
        <IconContext.Provider value={{ size: "2em", className: "text-white hover:text-gray-400 transition-colors" }}>
          <NavLink to={'/'}>
            <FaArrowCircleLeft />
          </NavLink>
        </IconContext.Provider>
      </div>
      
      {/* Titre de la page en haut */}
      <div className="pt-12 pb-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight">PORT<span className="text-gray-400">FOLIO</span></h1>
        <div className="w-24 h-1 bg-white mx-auto mt-4 mb-8"></div>
      </div>

      {/* Hero Section */}
      <section className="relative py-16 mb-8">
        <div className="max-w-7xl mx-auto px-4">
          <p className="text-xl text-gray-300 text-center max-w-3xl mx-auto">
            Découvrez mon univers à travers différents styles de photographie
          </p>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="max-w-7xl mx-auto px-4 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {/* Portraits */}
          <NavLink to="/Portrait" className="group">
            <div className="bg-[#16161e] rounded-lg overflow-hidden shadow-lg transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl h-[500px] flex flex-col border border-gray-800">
              <div className="relative h-80">
                <img
                  src={imageYohan}
                  alt="Portraits"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 group-hover:opacity-70 transition-opacity"></div>
              </div>
              <div className="p-8 flex flex-col flex-grow">
                <h3 className="text-2xl font-semibold mb-4 text-white">Portraits</h3>
                <p className="text-gray-300 leading-relaxed">
                  Capturer l'essence de chaque personnalité, immortaliser des moments authentiques et émouvants.
                </p>
              </div>
            </div>
          </NavLink>

          {/* Paysages */}
          <NavLink to="/Paysage" className="group">
            <div className="bg-[#16161e] rounded-lg overflow-hidden shadow-lg transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl h-[500px] flex flex-col border border-gray-800">
              <div className="relative h-80">
                <img
                  src={image20Ho}
                  alt="Paysages"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 group-hover:opacity-70 transition-opacity"></div>
              </div>
              <div className="p-8 flex flex-col flex-grow">
                <h3 className="text-2xl font-semibold mb-4 text-white">Paysages</h3>
                <p className="text-gray-300 leading-relaxed">
                  L'évasion par la beauté naturelle, des panoramas à couper le souffle.
                </p>
              </div>
            </div>
          </NavLink>

          {/* Événements */}
          <NavLink to="/Event" className="group">
            <div className="bg-[#16161e] rounded-lg overflow-hidden shadow-lg transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl h-[500px] flex flex-col border border-gray-800">
              <div className="relative h-80">
                <img
                  src={image4Ho}
                  alt="Événements"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 group-hover:opacity-70 transition-opacity"></div>
              </div>
              <div className="p-8 flex flex-col flex-grow">
                <h3 className="text-2xl font-semibold mb-4 text-white">Événements</h3>
                <p className="text-gray-300 leading-relaxed">
                  Explorez des instants magiques où chaque image raconte une histoire unique et mémorable.
                </p>
              </div>
            </div>
          </NavLink>

          {/* Tournage */}
          <NavLink to="/Tournage" className="group">
            <div className="bg-[#16161e] rounded-lg overflow-hidden shadow-lg transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl h-[500px] flex flex-col border border-gray-800">
              <div className="relative h-80">
                <img
                  src={image18Ho}
                  alt="Tournage"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 group-hover:opacity-70 transition-opacity"></div>
              </div>
              <div className="p-8 flex flex-col flex-grow">
                <h3 className="text-2xl font-semibold mb-4 text-white">Tournage</h3>
                <p className="text-gray-300 leading-relaxed">
                  Plongez dans l'univers créatif de notre photographe à travers des clips de tournage captivants.
                </p>
              </div>
            </div>
          </NavLink>
        </div>
      </section>
    </main>
  );
};
